import request from "@/service";

export function userCodeInfo(params) {
  return request({
    url: `/resource/userCode/infoNew/${params}`,
    method: "get",
  });
}
/**
 * 线上、线下预约用户列表
 * @param {*} params 
 * @returns 
 */
export function courseTicketUserRangePage(params) {
  return request({
    url: '/resource/courseTicketUserRange/page',
    method: 'get',
    params
  })
}
/**
 * 已预约用户列表
 * @param {*} params 
 * @returns 
 */
export function ticketUserPage(params) {
  return request({
    url: '/resource/ticketUser/page',
    method: 'get',
    params
  })
}

export function ticketUserDelete(data) {
  return request({
    url: '/resource/ticketUser/delete',
    method: 'post',
    data
  })
}

// 弹窗用户分页列表
export function queryRanageUser(data) {
  return request({
    url: '/resource/courseTicketUserRange/pagePopupUsers',
    method: 'post',
    data
  })
}

// 线上线下新增用户
export function addPopupUsers(data) {
  return request({
    url: '/resource/courseTicketUserRange/addPopupUsers',
    method: 'post',
    data
  })
}

export function addPopupDepts(data) {
  return request({
    url: '/resource/courseTicketUserRange/addPopupDepts',
    method: 'post',
    data
  })
}

export function ticketUserRangeImport(data) {
  return request({
    url: '/resource/courseTicketUserRange/import',
    method: 'post',
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data
  })
}

export function deleteTicketUser(data) {
  return request({
    url: '/resource/courseTicketUserRange/delete',
    method: 'post',
    data
  })
}
// 修改授权范围
export function ticketUserUpdateLimitType(params) {
  return request({
    url: '/resource/courseTicketUserRange/updateLimitType',
    method: 'get',
    params
  })
}

export function ticketUserExport(data) {
  return request({
    url: '/resource/courseTicketUserRange/export',
    method: 'post',
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  })
}

// 限制预约名单新增
export function ticketUserLimitSave(data) {
  return request({
    url: '/resource/ticketUser/limitSave',
    method: 'post',
    data
  })
}


export function ticketUserLimitDelete(data) {
  return request({
    url: '/resource/ticketUser/limitDelete',
    method: 'post',
    data
  })
}

// 
export function limitTicketUserExport(data) {
  return request({
    url: `/resource/ticketUser/limitexport`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}

// 
export function ticketUserLimitImport(data) {
  return request({
    url: '/resource/ticketUser/limitImport',
    method: 'post',
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data
  })
}

// 限制名单-数据初始化
export function ticketUserLimitInit(data) {
  return request({
    url: '/resource/ticketUser/limitInit',
    method: 'post',
    data
  })
}



export function hasTicketUserExport(data) {
  return request({
    url: `/resource/ticketUser/export`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}

// 已预约名单同步干部之家-hj
export function syncGbzj(data) {
  return request({
    url: '/resource/ticketUser/syncGbzj',
    method: 'post',
    data
  })
}

// 限制预约名单初始化-wangxf
export function limitInit(data) {
  return request({
    url: '/resource/ticketUser/limitInit',
    method: 'post',
    data
  })
}

export function courseTicketById(uuid) {
  return request({
    url: `/resource/courseTicket/manage/${uuid}`,
    method: 'get',
  })
}


/*********************----直播统计----************************* */


/**
 * 整体情况统计-wy
 * @param {*} uuid 
 * @returns 
 */
export function overallStatistics(uuid) {
  return request({
    url: `/resource/liveRoom/stats/overallStatistics/${uuid}`,
    method: 'get',
  })
}
/**
 * 直播咪咕统计-clc
 * @param {*} uuid 
 * @returns 
 */
export function miguStatistics(uuid) {
  return request({
    url: `/resource/liveRoom/stats/miguStatistics/${uuid}`,
    method: 'get',
  })
}
/**
 * 观看时长人数分析-clc
 * @param {*} uuid 
 * @returns 
 */
export function liveWatchTimeDistribute(uuid) {
  return request({
    url: `/resource/liveRoom/stats/queryLiveWatchTimeDistribute/${uuid}`,
    method: 'get',
  })
}

/**
 * 观看终端分析
 * @param {*} uuid 
 * @returns 
 */
export function liveDeviceStatistics(uuid) {
  return request({
    url: `/resource/liveRoom/stats/deviceStatistics/${uuid}`,
    method: 'get',
  })
}
/**
 * 观看用户学院分布
 * @param {*} uuid 
 * @returns 
 */
export function liveAcademyStatistics(uuid) {
  return request({
    url: `/resource/liveRoom/stats/academyStatistics/${uuid}`,
    method: 'get',
  })
}

/**
 * 观看用户管理类别人数-hj
 */
export function liveLeaderTypeStat(uuid)  {
  return request({
    url: `/resource/liveRoom/stats/leaderTypeStatistics/${uuid}`,
    method: 'get',
  })
}

/**
 * 直播间观看并发情况
 * @param {*} uuid 
 * @returns 
 */
export function historyOnlineNum(params)  {
  return request({
    url: `/resource/liveRoom/stats/historyOnlineNum`,
    method: 'get',
    params
  })
}
// 直播统计导出-hj
export function liveRoomStatsExport(uuid) {
  return request({
    url: `/resource/liveRoom/stats/export/${uuid}`,
    method: 'post',
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    }
  })
}

/**
 * 模块配置详情-clc
 */
export function indexModuleConfig()  {
  return request({
    url: `/resource/indexModuleConfig/infoDept`,
    method: 'get',
  })
}

// 模块配置编辑-clc
export function infoDeptUpdate(data) {
  return request({
    url: '/resource/indexModuleConfig/infoDeptUpdate',
    method: 'post',
    data
  })
}


// 预约首页入口配置详情-clc
export function getTicketDeptInfoVo(params)  {
  return request({
    url: `/resource/courseTicket/getTicketDeptInfoVo`,
    method: 'get',
    params
  })
}
/**
 * 预约首页入口配置更新-clc
 * @param {*} data 
 * @returns 
 */
export function ticketDeptUpdate(data)  {
  return request({
    url: `/resource/courseTicket/ticketDeptUpdate`,
    method: 'post',
    data
  })
}

/**
 * 模块配置同步学院-clc
 * @param {*} data 
 * @returns 
 */
export function pushCollege(data)  {
  return request({
    url: `/resource/indexModuleConfig/pushCollege`,
    method: 'post',
    data
  })
}
/**
 * CDN资源管理列表
 * @param {*} data 
 * @returns 
 */
export function cdnRecordPage(data)  {
  return request({
    url: `/resource/cdnRecord/page`,
    method: 'post',
    data
  })
}
/**
 * cdnRecord
 * @param {*} data 
 * @returns 
 */
export function cdnRecordDelete(data)  {
  return request({
    url: `/resource/cdnRecord/delete`,
    method: 'post',
    data
  })
}
/**
 * cdnRecord更新时间
 * @param {*} data 
 * @returns 
 */
export function cdnRecordUpdate(data)  {
  return request({
    url: `/resource/cdnRecord/update`,
    method: 'post',
    data
  })
}

// cdn加速导出-clc
export function exportCdnRecord(data) {
  return request({
    url: `/resource/cdnRecord/export`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}

/* cdn加速导入-clc */
export function importCdnRecord(params) {
  return request({
    url: `/resource/cdnRecord/import`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/foresource-data; boundary=----WebKitForesourceBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

/**
 * 直播授权范围列表-clc
 * 
 * 后端：陈立成
 */
export function getLiveRoomRuleList(params) {
  return request({
    url: `/resource/liveRoomRule/list`,
    method: "get",
    params
  })
}

/**
 * 新增-授权范围-clc
 * @param {*} data 
 * @returns 
 */
export function saveLiveRoomRule(data)  {
  return request({
    url: `/resource/liveRoomRule/save`,
    method: 'post',
    data
  })
}

/**
 * 授权范围详情-clc
 */
export function getLiveRoomRuleInfo(uuid)  {
  return request({
    url: `/resource/liveRoomRule/info/${uuid}`,
    method: 'get',
  })
}

/**
 * 删除-授权范围-clc
 * @param {*} data 
 * @returns 
 */
export function deleteLiveRoomRule(data)  {
  return request({
    url: `/resource/liveRoomRule/delete`,
    method: 'post',
    data
  })
}

/**
 * 小程序特色内容-clc
 */
export function getClientIndexConfigList(params)  {
  return request({
    url: `/resource/clientIndexConfig/list`,
    method: 'get',
    params
  })
}

// 新增小程序特色内容-clc
export function saveClientIndexConfig(data) {
  return request({
    url: '/resource/clientIndexConfig/save',
    method: 'post',
    data
  })
}

// 获取文章列表
export function getArticleByName(params) {
  return request({
    url: `/resource/periodical/article/namePage`,
    method: "get",
    params,
  });
}

// 删除-小程序特色内容-clc
export function deleteClientIndexConfig(data) {
  return request({
    url: '/resource/clientIndexConfig/delete',
    method: 'post',
    data
  })
}

// 上下线-小程序特色内容-clc
export function updateOnlineStatus(data) {
  return request({
    url: '/resource/clientIndexConfig/updateOnlineStatus',
    method: 'post',
    data
  })
}

// 共享列表-小程序特色内容-clc
export function getShareList(data) {
  return request({
    url: '/resource/clientIndexConfig/shareList',
    method: 'post',
    data
  })
}

// 保存共享列表-小程序特色内容-clc
export function saveShareList(data) {
  return request({
    url: '/resource/clientIndexConfig/saveShareList',
    method: 'post',
    data
  })
}
// 小程序特色内容-共享管理-恢复-wj
export function recoverShareList(data) {
  return request({
    url: '/resource/clientIndexConfig/recoverShareList',
    method: 'post',
    data
  })
}
// 取消共享-小程序特色内容-clc
export function cancelShareList(data) {
  return request({
    url: '/resource/clientIndexConfig/cancelShareList',
    method: 'post',
    data
  })
}

/**
 * 小程序特色内容-详情-clc
 */
export function clientIndexConfigInfo(uuid)  {
  return request({
    url: `/resource/clientIndexConfig/info/${uuid}`,
    method: 'get',
  })
}

/* 小程序特色内容-拖拽排序 */
export function orderByDrag(data) {
  return request({
    url: "/resource/clientIndexConfig/orderByDrag",
    method: "post",
    data
  });
}

// 直播管理-授权观看-导出手机号-clc
export function exportliveRoomRulePhone(params) {
  return request({
    url: `/resource/liveRoomRule/exportPhone`,
    method: "get",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    params
  });
}

/**
 * 直播管理-去重导出手机号-clc
 * @param {*} params 
 * @returns 
 */
export function exportLiveRoomUniquePhone(params) {
  return request({
    url: `/resource/liveRoomRule/exportPhoneUnique`,
    method: "get",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    params
  });
}


// 共享列表-期刊文章-clc
export function getArticleShareList(data) {
  return request({
    url: '/resource/periodical/article/shareList',
    method: 'post',
    data
  })
}

// 取消共享-期刊文章-clc
export function cancelArticleShareList(data) {
  return request({
    url: '/resource/periodical/article/cancelShareList',
    method: 'post',
    data
  })
}

// 保存共享列表-期刊文章-clc
export function saveArticleBatchShareList(data) {
  return request({
    url: '/resource/periodical/article/batchShare',
    method: 'post',
    data
  })
}

//  小程序主题色配置信息
export function getThemeConfig() {
  return request({
    url: '/resource/miniProgramThemeConfig/info',
    method: 'get',
  })
}
//  更新小程序主题色配置信息
export function updateThemeConfig(data) {
  return request({
    url: '/resource/miniProgramThemeConfig/saveOrUpdate',
    method: 'post',
    data
  })
}
// 保存共享列表-新闻-clc
export function saveNewsBatchShareList(data) {
  return request({
    url: '/resource/pub/news/batchShare',
    method: 'post',
    data
  })
}

// 取消共享-新闻-clc
export function cancelNewsShareList(data) {
  return request({
    url: '/resource/pub/news/cancelShareList',
    method: 'post',
    data
  })
}

// 共享列表-新闻-clc
export function getNewsShareList(data) {
  return request({
    url: '/resource/pub/news/shareList',
    method: 'post',
    data
  })
}
// 保存恢复共享列表-期刊文章-clc
export function batchRecoverShareList(data) {
  return request({
    url: '/resource/periodical/article/batchRecover',
    method: 'post',
    data
  })
}

// 保存恢复共享列表-新闻-clc
export function batchRecoverNewsShareList(data) {
  return request({
    url: '/resource/pub/news/batchRecover',
    method: 'post',
    data
  })
}

export function getLargeScreenAuthUrl() {
  return request({
    url: `/resource/largerScreen/authUrl`,
    method: "get",
  });
}


export function importOfflineVideo(params) {
  return request({
    url: `/resource/video/info/importOffline`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/foresource-data; boundary=----WebKitForesourceBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

export function importOfflineVideoSet(params) {
  return request({
    url: `/resource/video/set/importOffline`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/foresource-data; boundary=----WebKitForesourceBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}




